import {
  GET_FEEDBACK_REQUEST,
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_FAILURE,
} from "../../actionTypes";

export const getFeedbackRequest = (page, per_page, data, column, direction) => ({
  type: GET_FEEDBACK_REQUEST,
  payload: {page, per_page, data, column, direction},
});

export const getFeedbackSuccess = (data) => ({
  type: GET_FEEDBACK_SUCCESS,
  payload: data,
});

export const getFeedbackFailure = (error) => ({
  type: GET_FEEDBACK_FAILURE,
  payload: error,
});
